import React from 'react';
import PropTypes from 'prop-types';
import { Popover, MenuItem } from '@mui/material';
import ProtectedComponent from '../../../components/protected/ProtectedComponent';
import Iconify from '../../../components/iconify';

const ActionsPopover = ({ open, onClose, onEditClick, onDeleteClick }) => (
  <Popover
    open={Boolean(open)}
    anchorEl={open}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    PaperProps={{
      sx: {
        p: 1,
        width: 140,
        '& .MuiMenuItem-root': {
          px: 1,
          typography: 'body2',
          borderRadius: 0.75,
        },
      },
    }}
  >
    <ProtectedComponent permission={'EDIT_CLIENT'}>
      <MenuItem onClick={onEditClick}>
        <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
        Edit
      </MenuItem>
    </ProtectedComponent>
    <ProtectedComponent permission={'DELETE_CLIENT'}>
      <MenuItem onClick={onDeleteClick} sx={{ color: 'error.main' }}>
        <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
        Delete
      </MenuItem>
    </ProtectedComponent>
  </Popover>
);

ActionsPopover.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default ActionsPopover;
